import { render, staticRenderFns } from "./UserResetPassword.vue?vue&type=template&id=86bc1362&"
import script from "./UserResetPassword.js?vue&type=script&lang=js&"
export * from "./UserResetPassword.js?vue&type=script&lang=js&"
import style0 from "./UserResetPassword.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports